import React from 'react'
import cx from 'classnames'
import './Button.scss'

const noop = () => {}

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  icon?: boolean
  label?: React.ReactNode
  outline?: boolean
  primary?: boolean
  small?: boolean
  submit?: boolean
  text?: boolean
  warning?: boolean
}

const Button = ({
  className,
  label = null,
  title,
  primary = false,
  outline = false,
  warning = false,
  submit = false,
  small = false,
  text = false,
  icon = false,
  onClick = submit ? noop : undefined,
  disabled = !onClick,
  children,
  ...props
}: ButtonProps) => (
  <button
    title={title}
    tabIndex={0}
    type={submit ? 'submit' : 'button'}
    className={cx(
      'Button',
      {
        icon,
        outline,
        warning,
        primary,
        small,
        text,
      },
      className,
    )}
    onClick={e => {
      if (!submit) e.preventDefault()
      e.stopPropagation()
      onClick && onClick(e)
    }}
    {...props}
    disabled={disabled}
  >
    {label && <div className="buttonLabel">{label}</div>}
    {children}
  </button>
)

export default Button
